import { render, staticRenderFns } from "./BusinessIntroductionPage.vue?vue&type=template&id=55f09a52&scoped=true&"
import script from "./BusinessIntroductionPage.vue?vue&type=script&lang=js&"
export * from "./BusinessIntroductionPage.vue?vue&type=script&lang=js&"
import style0 from "./BusinessIntroductionPage.vue?vue&type=style&index=0&id=55f09a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f09a52",
  null
  
)

export default component.exports